/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../Fixes';
import Builder from '../../../Builder';
import '../../common/currency';
import '../common/component/card_accessory';
import '../common/component/component';
import '../common/workflow/ui_elements/common';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "bbfrontend": {
        "nested": {
          "service": {
            "nested": {
              "v1": {
                "nested": {
                  "BankingHomeCreditCardSection": {
                    "fields": {
                      "creditCards": {
                        "type": ".squareup.bbfrontend.service.v1.BankingHomeCreditCardSection.CreditCard",
                        "id": 1,
                        "rule": "repeated"
                      }
                    },
                    "nested": {
                      "CreditCard": {
                        "fields": {
                          "creditLineId": {
                            "type": "string",
                            "id": 1,
                            "rule": "optional"
                          },
                          "state": {
                            "type": ".squareup.bbfrontend.service.v1.BankingHomeCreditCardSection.CreditCard.CardState",
                            "id": 2,
                            "rule": "optional"
                          },
                          "cardHolderName": {
                            "type": "string",
                            "id": 3,
                            "rule": "optional"
                          },
                          "cardDisplayName": {
                            "type": "string",
                            "id": 4,
                            "rule": "optional"
                          },
                          "balance": {
                            "type": ".squareup.common.Money",
                            "id": 5,
                            "rule": "optional"
                          },
                          "creditLimit": {
                            "type": ".squareup.common.Money",
                            "id": 6,
                            "rule": "optional"
                          },
                          "shippingState": {
                            "type": ".squareup.bbfrontend.service.v1.BankingHomeCreditCardSection.CreditCard.ShippingState",
                            "id": 7,
                            "rule": "optional"
                          },
                          "trailingBanner": {
                            "type": ".squareup.bbfrontend.service.v1.BankingHomeCreditCardSection.Banner",
                            "id": 8,
                            "rule": "optional"
                          },
                          "cardLeadingAccessory": {
                            "type": ".squareup.bbfrontend.common.component.CardAccessoryDescription",
                            "id": 9,
                            "rule": "optional"
                          }
                        },
                        "nested": {
                          "CardState": {
                            "values": {
                              "ACTIVE": 0,
                              "LOCKED": 1,
                              "FRAUD_BLOCKED": 2,
                              "TERMINATED": 3
                            }
                          },
                          "ShippingState": {
                            "fields": {
                              "status": {
                                "type": ".squareup.bbfrontend.service.v1.BankingHomeCreditCardSection.CreditCard.ShippingState.Status",
                                "id": 1,
                                "rule": "optional"
                              },
                              "activateCardUrl": {
                                "type": ".squareup.bbfrontend.common.component.WebURL",
                                "id": 2,
                                "rule": "optional"
                              }
                            },
                            "nested": {
                              "Status": {
                                "values": {
                                  "PRINTING": 1,
                                  "ON_THE_WAY": 2,
                                  "ACTIVATE": 3
                                }
                              }
                            }
                          }
                        }
                      },
                      "Banner": {
                        "fields": {
                          "description": {
                            "type": ".squareup.bbfrontend.common.component.BannerDescription",
                            "id": 1,
                            "rule": "optional"
                          },
                          "action": {
                            "type": ".squareup.bbfrontend.service.v1.BankingHomeCreditCardSection.Banner.BannerAction",
                            "id": 2,
                            "rule": "repeated"
                          }
                        },
                        "nested": {
                          "BannerAction": {
                            "fields": {
                              "text": {
                                "type": "string",
                                "id": 1,
                                "rule": "optional"
                              },
                              "logEvent": {
                                "type": ".squareup.bbfrontend.service.v1.LogEvent",
                                "id": 4,
                                "rule": "optional"
                              },
                              "openExternalUrl": {
                                "type": ".squareup.bbfrontend.common.component.WebURL",
                                "id": 2
                              },
                              "reviewCreditLimit": {
                                "type": ".squareup.bbfrontend.service.v1.BankingHomeCreditCardSection.Banner.BannerAction.ReviewCreditLimit",
                                "id": 3
                              }
                            },
                            "nested": {
                              "ReviewCreditLimit": {
                                "fields": {
                                  "creditLimitChangeId": {
                                    "type": "string",
                                    "id": 1,
                                    "rule": "optional"
                                  }
                                }
                              },
                              "action": {
                                "oneof": ["openExternalUrl", "reviewCreditLimit"]
                              }
                            }
                          }
                        }
                      }
                    }
                  },
                  "BankingHomeCreditCardApplication": {
                    "fields": {
                      "cardLeadingAccessory": {
                        "type": ".squareup.bbfrontend.common.component.CardAccessoryDescription",
                        "id": 4,
                        "rule": "optional"
                      },
                      "inProgress": {
                        "type": ".squareup.bbfrontend.service.v1.BankingHomeCreditCardApplication.InProgress",
                        "id": 1
                      },
                      "awaitingReview": {
                        "type": ".squareup.bbfrontend.service.v1.BankingHomeCreditCardApplication.AwaitingReview",
                        "id": 2
                      },
                      "declined": {
                        "type": ".squareup.bbfrontend.service.v1.BankingHomeCreditCardApplication.Declined",
                        "id": 3
                      }
                    },
                    "nested": {
                      "InProgress": {
                        "fields": {
                          "continueApplicationUrl": {
                            "type": ".squareup.bbfrontend.common.component.WebURL",
                            "id": 2,
                            "rule": "optional"
                          }
                        }
                      },
                      "AwaitingReview": {
                        "fields": {}
                      },
                      "Declined": {
                        "fields": {}
                      },
                      "state": {
                        "oneof": ["inProgress", "awaitingReview", "declined"]
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.bbfrontend?.nested?.service?.nested?.v1?.nested?.BankingHomeCreditCardSection && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.service?.nested?.v1?.nested?.BankingHomeCreditCardSection?.nested?.CreditCard && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.service?.nested?.v1?.nested?.BankingHomeCreditCardSection?.nested?.CreditCard?.nested?.CardState && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.service?.nested?.v1?.nested?.BankingHomeCreditCardSection?.nested?.CreditCard?.nested?.ShippingState && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.service?.nested?.v1?.nested?.BankingHomeCreditCardSection?.nested?.CreditCard?.nested?.ShippingState?.nested?.Status && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.service?.nested?.v1?.nested?.BankingHomeCreditCardSection?.nested?.Banner && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.service?.nested?.v1?.nested?.BankingHomeCreditCardSection?.nested?.Banner?.nested?.BannerAction && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.service?.nested?.v1?.nested?.BankingHomeCreditCardSection?.nested?.Banner?.nested?.BannerAction?.nested?.ReviewCreditLimit && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.service?.nested?.v1?.nested?.BankingHomeCreditCardApplication && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.service?.nested?.v1?.nested?.BankingHomeCreditCardApplication?.nested?.InProgress && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.service?.nested?.v1?.nested?.BankingHomeCreditCardApplication?.nested?.AwaitingReview && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.service?.nested?.v1?.nested?.BankingHomeCreditCardApplication?.nested?.Declined) {
  $root.addJSON(jsonData);
}

/**
 * Used for rendering the Back Office's Banking tab's home screen.
 * Render the Credit Card section for existing credit cards.
 *
 * SOURCE BankingHomeCreditCardSection @ squareup/bbfrontend/v1/banking_home_sections.proto at 22:1
 */
export const BankingHomeCreditCardSection = $root.lookupType('squareup.bbfrontend.service.v1.BankingHomeCreditCardSection');
fixType(BankingHomeCreditCardSection, {
  creditCards: {
    required: true
  }
});
Builder.createAndAttachToType(BankingHomeCreditCardSection);
/**
 * SOURCE CreditCard @ squareup/bbfrontend/v1/banking_home_sections.proto at 25:3
 */
BankingHomeCreditCardSection.CreditCard = $root.lookupType('squareup.bbfrontend.service.v1.BankingHomeCreditCardSection.CreditCard');
fixType(BankingHomeCreditCardSection.CreditCard, {
  creditLineId: {
    notEmpty: true
  },
  state: {
    required: true
  },
  cardHolderName: {
    notEmpty: true
  },
  cardDisplayName: {
    notEmpty: true
  },
  cardLeadingAccessory: {
    required: true
  }
});
Builder.createAndAttachToType(BankingHomeCreditCardSection.CreditCard);
/**
 * SOURCE CardState @ squareup/bbfrontend/v1/banking_home_sections.proto at 43:5
 */
BankingHomeCreditCardSection.CreditCard.CardState = $root.lookupEnum('squareup.bbfrontend.service.v1.BankingHomeCreditCardSection.CreditCard.CardState').values;
/**
 * SOURCE ShippingState @ squareup/bbfrontend/v1/banking_home_sections.proto at 50:5
 */
BankingHomeCreditCardSection.CreditCard.ShippingState = $root.lookupType('squareup.bbfrontend.service.v1.BankingHomeCreditCardSection.CreditCard.ShippingState');
fixType(BankingHomeCreditCardSection.CreditCard.ShippingState, {
  status: {
    required: true
  }
});
Builder.createAndAttachToType(BankingHomeCreditCardSection.CreditCard.ShippingState);
/**
 * SOURCE Status @ squareup/bbfrontend/v1/banking_home_sections.proto at 56:7
 */
BankingHomeCreditCardSection.CreditCard.ShippingState.Status = $root.lookupEnum('squareup.bbfrontend.service.v1.BankingHomeCreditCardSection.CreditCard.ShippingState.Status').values;
/**
 * SOURCE Banner @ squareup/bbfrontend/v1/banking_home_sections.proto at 64:3
 */
BankingHomeCreditCardSection.Banner = $root.lookupType('squareup.bbfrontend.service.v1.BankingHomeCreditCardSection.Banner');
fixType(BankingHomeCreditCardSection.Banner, {
  description: {
    required: true
  }
});
Builder.createAndAttachToType(BankingHomeCreditCardSection.Banner);
/**
 * SOURCE BannerAction @ squareup/bbfrontend/v1/banking_home_sections.proto at 68:5
 */
BankingHomeCreditCardSection.Banner.BannerAction = $root.lookupType('squareup.bbfrontend.service.v1.BankingHomeCreditCardSection.Banner.BannerAction');
fixType(BankingHomeCreditCardSection.Banner.BannerAction, {
  text: {
    notEmpty: true
  }
});
Builder.createAndAttachToType(BankingHomeCreditCardSection.Banner.BannerAction);
/**
 * SOURCE ReviewCreditLimit @ squareup/bbfrontend/v1/banking_home_sections.proto at 78:7
 */
BankingHomeCreditCardSection.Banner.BannerAction.ReviewCreditLimit = $root.lookupType('squareup.bbfrontend.service.v1.BankingHomeCreditCardSection.Banner.BannerAction.ReviewCreditLimit');
fixType(BankingHomeCreditCardSection.Banner.BannerAction.ReviewCreditLimit, {
  creditLimitChangeId: {
    notEmpty: true
  }
});
Builder.createAndAttachToType(BankingHomeCreditCardSection.Banner.BannerAction.ReviewCreditLimit);
/**
 * Render the Credit Card section for when there's an application for opening a card.
 *
 * SOURCE BankingHomeCreditCardApplication @ squareup/bbfrontend/v1/banking_home_sections.proto at 88:1
 */
export const BankingHomeCreditCardApplication = $root.lookupType('squareup.bbfrontend.service.v1.BankingHomeCreditCardApplication');
fixType(BankingHomeCreditCardApplication, {
  cardLeadingAccessory: {
    required: true
  }
});
Builder.createAndAttachToType(BankingHomeCreditCardApplication);
/**
 * The customer has started an application but not yet finished.
 * Note: This can include the states where the card is being
 * automatically reviewed/finalized, since those states are measured in seconds.
 *
 * SOURCE InProgress @ squareup/bbfrontend/v1/banking_home_sections.proto at 102:3
 */
BankingHomeCreditCardApplication.InProgress = $root.lookupType('squareup.bbfrontend.service.v1.BankingHomeCreditCardApplication.InProgress');
fixType(BankingHomeCreditCardApplication.InProgress);
Builder.createAndAttachToType(BankingHomeCreditCardApplication.InProgress);
/**
 * The customer has submitted an application and it is awaiting manual review.
 *
 * SOURCE AwaitingReview @ squareup/bbfrontend/v1/banking_home_sections.proto at 109:3
 */
BankingHomeCreditCardApplication.AwaitingReview = $root.lookupType('squareup.bbfrontend.service.v1.BankingHomeCreditCardApplication.AwaitingReview');
fixType(BankingHomeCreditCardApplication.AwaitingReview);
Builder.createAndAttachToType(BankingHomeCreditCardApplication.AwaitingReview);
/**
 * The customer's application was denied.
 *
 * SOURCE Declined @ squareup/bbfrontend/v1/banking_home_sections.proto at 114:3
 */
BankingHomeCreditCardApplication.Declined = $root.lookupType('squareup.bbfrontend.service.v1.BankingHomeCreditCardApplication.Declined');
fixType(BankingHomeCreditCardApplication.Declined);
Builder.createAndAttachToType(BankingHomeCreditCardApplication.Declined);